import { createFileRoute } from '@tanstack/react-router'

import { SpecPage } from '@/components/spec/spec-page'
import { useFollowProjectClient } from '@/hooks/use-current-client'
import { oneOf, readSearch } from '@/lib/search-params'

const SHAPE = {
  /**
   * Travail (la liste des sections) ou lecture suivie, imprimable. Nommé
   * `cahier` et non `vue` : les vues des tâches portent déjà `vue`, et deux
   * routes qui donnent deux sens au même paramètre brouillent les liens.
   */
  cahier: oneOf(['liste', 'lecture'] as const),
  /** Lecture : quelle révision de chaque section (contrat 1.34.0). */
  version: oneOf(['current', 'submitted', 'approved'] as const),
}

export const Route = createFileRoute('/_app/projects/$projectRef_/cahier')({
  validateSearch: (search: Record<string, unknown>) => readSearch(SHAPE, search),
  component: SpecRoutePage,
})

function SpecRoutePage() {
  const { projectRef } = Route.useParams()
  useFollowProjectClient(projectRef)
  const { cahier, version } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <SpecPage
      projectRef={projectRef}
      view={cahier ?? 'liste'}
      content={version ?? 'current'}
      onNavigate={(next) => {
        void navigate({ search: (previous) => ({ ...previous, ...next }), replace: true })
      }}
    />
  )
}
